import React from 'react';
import { translate } from '../../../../base/i18n';
import Dialog from '../../../../base/ui/components/web/Dialog';

const ForgotPassDialog = ({onCancel}) => {
    return (
        <Dialog
            cancel={{ hidden: true }}
            ok={{ hidden: true }}
            onCancel={onCancel}
            width = { 'small' }
        >
            <div className={'subscribe-modal'}>
                <h4 className={'color-white'}>Forgot Password!</h4>
                <div className={'title-underline'}></div>
                <div className={'description color-white'}>You will receive an email to reset the password.</div>
            </div>
        </Dialog>
    )
}
export default translate(ForgotPassDialog);